export function PageLoader() {
  return (
    <div className="page page-center">
      <div className="container container-tight py-4">
        <div className="text-center">
          <div className="mb-3">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          <div className="text-muted">Ładowanie aplikacji...</div>
        </div>
      </div>
    </div>
  );
}
